module.exports = __webpack_public_path__ + "img/1.867fe700.jpg";